import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const InternalTransactionStepConfirm = ({
  txnPayLoad,
  setTxnPayLoad,
  isConfidential,
  refactor,
  previewImages,
  allLabels,
}) => {
  return (
    <>
      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md max-w-tab-width-normal mx-auto ${refactor ? "Qmd:py-padding-md py-padding-base" : "py-padding-md"}`}
      >
        <CommonLayout>
          <SourceDestinationAccountDetail
            type="source"
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            page="confirm"
          />

          <SourceDestinationAccountDetail
            type="destination"
            flow="internal"
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            page="confirm"
          />

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={isConfidential}
            isPreview={true}
          />

          <div className="lg:max-w-[var(--create-box-width)] w-width-full">
            <AdditionalDetailsPreviewMapper
              mappingData={txnPayLoad.mergeCategory}
              previewImages={previewImages}
            />
          </div>

          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount
              isPreview={true}
              txnPayLoad={txnPayLoad}
            />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={txnPayLoad?.settleType}
            />
          </div>

          <AssignLabels
            labels={allLabels}
            isOptional={true}
            previewMode={true}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default InternalTransactionStepConfirm;
